import { z } from "zod";

// Schemas

export const EmailTemplateSchema = z.object({
  subject: z.string(),
  html: z.string(),
  text: z.string().optional(),
});
